<a-small-folder-display *ngFor="let folder of folders; let first = first; let last = last"
                        [isFirst]="first"
                        [isLast]="last"
                        [folder]="folder"
                        (click)="changePath(folder.path)"></a-small-folder-display>
